<style>
</style>
<template>
  <v-container fluid id="my--summary">
  <v-container fluid style="max-width: 960px;">
  <v-col mt-3 mb-5>
    <v-progress-linear :indeterminate="!isLoaded" v-if="!isLoaded"></v-progress-linear>
    <v-card flat mt-3 mb-5 v-if="isLoaded">
      <my-summary-chart :width="400" :height="200" style="position: relative;" :data="chartData" :options="chartOptions"></my-summary-chart>
    </v-card>
  </v-col>
  </v-container>
<!--    <v-row class="background: grey lighten-1">-->
<!--      <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
<!--      <v-alert type="info" color="grey lighten-1">{{ $t('Zde najdete přehled o svých aktuálních aktivitách') }}</v-alert>-->
<!--      </v-container>-->
<!--    </v-row>-->
  </v-container>
</template>
<script>
import CustomerMixin from '@/mixins/customer-mixin.js'
import MySummaryChart from '@/components/my-summary-chart.vue'
import moment from 'moment'

const _ = require('lodash')

export default {
  mixins: [CustomerMixin],
  props: {
    visits: {
      type: Array,
      default: null
    },
    charges: {
      type: Array,
      default: null
    },
    documents: {
      type: Array,
      default: null
    },
    reservations: {
      type: Array,
      default: null
    },
    orders: {
      type: Array,
      default: null
    }
  },
  components: {
    'my-summary-chart': MySummaryChart
  },
  data() {
    return {
      // myCharges:
    }
  },
  computed: {
    isLoaded() {
      return !!this.visits && !!this.charges
    },
    now() {
      return Date.now()
    },
    reversedLastVisits() {
      // var vs = this.visits
      // if (vs !== null && vs.length > 0) {
      //   vs = _.sortBy(vs, ['startTime'])
      //   vs = _.reverse(vs)
      //   return vs.slice(0, Math.min(10, vs.length))
      // }
      // return null
      return _.minBy(this.customerData.visits, 'startTime')
    },
    reversedLastCharges() {
      // var vs = this.charges
      // if (vs !== null && vs.length > 0) {
      //   vs = _.sortBy(vs, ['transactionDate'])
      //   vs = _.reverse(vs)
      //   return vs.slice(0, Math.min(10, vs.length))
      // }
      // return null
      return _.minBy(this.customerData.visits, 'transactionDate')
    },
    lastDocuments() {
      // let docs = this.documents
      // if (docs !== null && docs.length > 0) {
      //   docs = _.sortBy(docs, ['file.date'])
      //   docs = _.reverse(docs)
      //   return docs.slice(0, Math.min(10, docs.length))
      // }
      // return null
      return _.minBy(this.customerData.visits, 'file.date')
    },
    scheduledReservations() {
      const rs = this.reservations
      let srs = null
      if (rs !== null && rs.length > 0) {
        const time = new Date()
        srs = _.filter(rs, function(r) {
          return r.validFromMoment.toDate() > time
        })
        if (srs !== null) {
          srs = _.sortBy(srs, ['validFrom'])
        }
      }
      return srs !== null && srs.length > 0 ? srs : null
    },
    lastMonths() {
      let array = []
      let m = moment()
      for (let i = 0; i < 12; i++) {
        array.push(m.format('MM.YYYY'))
        m = m.subtract(1, 'months')
      }
      return array.reverse()
    },
    lastVisits() {
      let array = []
      let m = moment()
      for (let i = 0; i < 12; i++) {
        let count = 0
        const vcount = this.visits ? this.visits.length : 0
        for (let j = 0; j < vcount; j++) {
          const vt = moment(this.visits[j].startTime, 'YYYY-MM-DD HH:mm:ss.SSSSSSSSS z')
          if (m.year() === vt.year() && m.month() === vt.month()) count++
        }
        array.push(count)
        m = m.subtract(1, 'months')
      }
      return array.reverse()
    },
    lastCharges() {
      let array = []
      let m = moment()
      for (let i = 0; i < 12; i++) {
        let amount = 0
        const vcount = this.charges ? this.charges.length : 0
        for (let j = 0; j < vcount; j++) {
          const vt = moment(this.charges[j].transactionDate, 'YYYY-MM-DD HH:mm:ss.SSSSSSSSS z')
          if (m.year() === vt.year() && m.month() === vt.month()) amount += this.charges[j].amount / 100.0
        }
        array.push(amount)
        m = m.subtract(1, 'months')
      }
      return array.reverse()
    },
    chartData: {
      get() {
        return {
          labels: this.lastMonths,
          datasets: [{
            label: 'Počet návštěv',
            data: this.lastVisits,
            backgroundColor: 'rgba(255, 99, 132, 0.2)',
            borderColor: 'rgba(255,99,132,1)',
            borderWidth: 1,
            yAxisID: 'first-y-axis'
          }, {
            label: 'Částka nabití',
            data: this.lastCharges,
            backgroundColor: 'rgba(54, 162, 235, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1,
            yAxisID: 'second-y-axis'
          }]
        }
      }
    },
    chartOptions: {
      get() {
        return {
          // responsive: false,
          // maintainAspectRatio: false,
          scales: {
            yAxes: [{
              id: 'first-y-axis',
              position: 'left',
              ticks: {
                beginAtZero: true
              }
            }, {
              id: 'second-y-axis',
              position: 'right',
              ticks: {
                beginAtZero: true
              }
            }]
          }
        }
      }
    }
  }
}
</script>
